// extracted by mini-css-extract-plugin
module.exports = {"playBtn":"_20e4c5dd13069dde5efa1cdcf208f312","player":"d7a3a0eb994f1047c6180e4f1e9b325e"};